import { motion } from "framer-motion";

export const EASE = [0.215, 0.61, 0.355, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Stagger({ children, className = "", gap = 0.1 }) {
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.12 }}
      variants={{ hidden: {}, show: { transition: { staggerChildren: gap } } }}
    >
      {children}
    </motion.div>
  );
}

export function StaggerItem({ children, className = "" }) {
  return (
    <motion.div
      className={className}
      variants={{ hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0, transition: { duration: 0.65, ease: EASE } } }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClass = "", delay = 0, as: Tag = "h1" }) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => {
        const text = typeof line === "string" ? line : line.text;
        const cls = typeof line === "string" ? lineClass : line.cls || lineClass;
        return (
          <span key={i} className="mask-line">
            <motion.span
              className={`block ${cls}`}
              initial={{ y: "112%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 0.9, delay: delay + i * 0.13, ease: EASE }}
            >
              {text}
            </motion.span>
          </span>
        );
      })}
    </Tag>
  );
}
